import { boolean } from "yup";
import API_ROUTES from "../constant/API_ROUTES";
import axiosClient from "../interceptor";

export const getCalendar = async (date: string | null = null) => {
  const queryParams = date ? { date } : {};

  const res = await axiosClient.get(API_ROUTES.CALENDAR_DETAILS, {
    params: queryParams,
  });
  return res.data.data || undefined;
};

export const postAdviseForm = async (
  name: string,
  phone: string,
  message?: string,
  email?: string,
  address?: string,
) => {
  const res = await axiosClient.post("/advise", {
    name,
    phone,
    message,
    address,
    email,
    type: "xheroapp",
  });
  return res.data || undefined;
};

export interface IPostTracking {
  url: string;
  deviceId: string;
}

export const postTracking = async (body: IPostTracking) => {
  const res = await axiosClient.post("/tracking", body);
  return res.data.data;
};

export const getCalendarPerpetual = async (
  fromDate: string,
  toDate: string,
  isAll: boolean,
  limitPerPage?: number
) => {
  const res = await axiosClient.get(API_ROUTES.CALENDAR_PERPETUAL, {
    params: {
      fromDate,
      toDate,
      isAll,
    },
  });

  return res.data.data || [];
};

export const getCalendarPerpetualPDF = async (
  fromDate: string,
  toDate: string,
  isAll: boolean,
  limitPerPage?: number
) => {
  const res = await axiosClient.get(API_ROUTES.CALENDAR_PERPETUAL_PDF, {
    params: {
      fromDate,
      toDate,
      isAll,
      limitPerPage
    },
  });

  return res.data.data || [];
};